import { Box, styled } from '@mui/material';
import { FC, ReactNode, useEffect } from 'react';
import logger from '../services/loggerManager';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Typography } from '@chargeafter/ui';
import { useResetCurrentModal } from '../services/modalManager';

type NoteModalProps = {
  title: string;
  content: ReactNode;
  close: (() => void) | null;
  updateClose: (func: () => void) => void;
  showWarningIcon?: boolean;
};

const Container = styled(Box)({
  minWidth: '50vw',
});

const StyledTitle = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(1),
  paddingLeft: theme.spacing(3),
  backgroundColor: theme.palette.secondary.light,
  fontSize: '16pt',
  color: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const StyledContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
}));

const NoteModal: FC<NoteModalProps> = ({
  title,
  content,
  updateClose,
  showWarningIcon,
}) => {
  const resetCurrentModal = useResetCurrentModal();

  useEffect(() => {
    updateClose(() => () => {
      resetCurrentModal();
      logger.log(`Closed send link modal`, {
        filename: 'SendLinkModal.tsx',
        function: 'closeModal',
      });
    });
  }, []);

  return (
    <Container data-testid="note-modal">
      <StyledTitle variant="h3">
        {showWarningIcon && <ErrorOutlineIcon fontSize="large" />}
        {title}
      </StyledTitle>
      <StyledContent>{content}</StyledContent>
    </Container>
  );
};

export { NoteModal };
